'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/* eslint-disable camelcase */
function _PortalPresenter() {
  var _this2 = this;

  this.extends = [_Secured, _ResponsiveLayout, _AnalyticsData, _ErrorController, _StateController, _LayoutActions, _MobileAPI, _BranchIO, _Firebase, EasterEgg];
  this.presenter = new APIPresenter();
  this.presenter._contentLoadedPromise = $.Deferred();
  this.presenter._featureFlagsLoadedPromise = $.Deferred();
  this.presenter.featureControls = new FeatureControl(this.presenter);
  this._initialized = false;
  this._animated = false; // buggy
  this._productSettings = new ProductSettings(this.presenter);
  this._indexTrustedDevices = 'account.index_authenticated_devices';

  this._browserlanguage = null;
  this._usrLanguage = null;

  this._linkMap = {
    account: {
      create_credit_application: {
        method: 'post',
        uri: '/credit_applications'
      }
    }
  };

  this._transitionEndEvents = {
    WebkitTransition: 'webkitTransitionEnd',
    OTransition: 'oTransitionEnd',
    msTransition: 'msTransitionEnd',
    transition: 'transitionend'
  };
  // transition end event name
  this._transitionEnd = this._transitionEndEvents[Modernizr.prefixed('transition')];

  this._classes = {
    // Elements
    inner: '.portal__inner',
    nav: '.portal__nav',
    nav_items: '.portal__nav__items',
    nav_mobile: '.portal__nav__mobile',
    nav_mobile_icon: '.portal__nav__mobile .icon-menu',
    content: '.portal__content',
    nav_toggle: '.js--toggle-nav',
    help_links: '.js--help-link',

    // States
    expanded: 'portal--expanded-nav',
    collapsed: 'portal--collapsed-nav',
    account_loaded: 'portal--account-loaded',

    // Layout states
    layout_transition: 'portal--transition',
    layout_loader: 'portal--dashboard-loader',
    layout_default: 'portal--default',
    layout_default_no_side: 'portal--default-noside',
    layout_tray_no_side: 'portal--tray-noside',
    layout_tray: 'portal--tray',
    layout_tray_side_only: 'portal--tray-sideonly',
    layout_top_tray: 'portal--top-tray-default'
  };

  this._viewStates = {
    portal__primary: {
      status: 'complete', // Tracks page load status: pending, contentful, complete
      contentful: {} // Tracks contentful requests
    },
    portal__tray: {
      status: 'complete',
      contentful: {}
    },
    portal__subnav: {
      status: 'complete',
      contentful: {}
    },
    portal__trayside: {
      status: 'complete',
      contentful: {}
    },
    portal__primary_toptray: {
      status: 'complete',
      contentful: {}
    }
  };

  this._DEBUG = false;

  this.init = function () {
    this._super();
    this._initHistory();
    this.createStore(); // create state object

    // Mobile API
    this.initMobileAPI();

    this.branchIOInit();

    this.firebaseInit();

    this.analytics = new Analytics();
    this.analytics.update(this.analyticsData, this);

    this.$node = $(this.node);

    this._browserlanguage = navigator.language || navigator.userLanguage;
    document.documentElement.setAttribute('lang', this._browserlanguage);

    this._$primary = this.$node.find('.portal__primary');
    this._$subnav = this.$node.find('.portal__subnav');
    this._$tray = this.$node.find('.portal__tray');
    this._$trayside = this.$node.find('.portal__trayside');
    this._$toptray = this.$node.find('.portal__primary_toptray');

    this._$notification = $('#Notification').mogo();
  };

  this.initAllReady = function () {
    this._getAccountModel();
    this._displayNotifications(getURLParameter('notification').trim());
    this.easterEggInit();

    this.analytics.pushEvent('account-status', {
      AccountStatus: ['login-success']
    });

    $(window).on('logout', function () {
      var _window = window,
          analytics = _window.analytics;

      analytics.track('Member Logged Out');
      analytics.reset();
    });
  };

  this._displayNotifications = function (notification) {
    this._usrLanguage = this._browserlanguage.toLowerCase();

    var isFrenchBrowserUser = this._usrLanguage === 'fr' || this._usrLanguage === 'fr-fr' || this._usrLanguage === 'fr-ca';
    var local = isFrenchBrowserUser ? 'fr' : 'en';

    // note: the french translations here come from https://www.deepl.com/translator
    var content = {
      email_verified: {
        en: 'Awesome, your email is now verified!',
        fr: 'Super, votre e-mail est maintenant vérifié !'
      },
      already_verified: {
        en: "Woah, that link's expired like last week's milk.",
        fr: 'Lien expiré'
      },
      password_changed: {
        en: "Boom. You've got a new password!",
        fr: 'Mot de passe modifié'
      }
    };

    switch (notification) {
      case 'email-verified':
        this._$notification.create({
          type: 'success',
          msg: content.email_verified[local]
        });
        this.analytics.pushEvent('account-status', {
          AccountStatus: [notification]
        });
        break;
      case 'already-verified':
        this._$notification.create({
          type: 'warning',
          msg: content.already_verified[local]
        });
        this.analytics.pushEvent('account-status', {
          AccountStatus: [notification]
        }); // does not exist in data but keeping existing state.
        break;
      case 'password-changed':
        this._$notification.create({
          type: 'success',
          msg: content.password_changed[local]
        });
        this.analytics.pushEvent('account-status', {
          AccountStatus: [notification]
        });
        break;
      default:
        break;
    }
  };

  this._getAccountModel = function () {
    this.presenter.createModel('account', {
      uri: '/accounts'
    }, this._onGetAccountModel.bind(this));
  };

  this._onGetAccountModel = function (data, response) {
    var _this = this;

    if (this.isGeneralConnectionIssue(data, response)) {
      var req = new APIRequest('/accounts', 'GET', null, this._onGetAccountModel.bind(this));
      this.invokeConnectionIssuePage(req, {
        productLabel: 'MogoMember'
      });
    } else {
      this.presenter.updateModel('account', data);
      this.presenter.featureControls.injectLocalValues();
      this.presenter.scanDOM($(this._classes.nav));
      this.$node.addClass(this._classes.account_loaded);
      this._initialized = true;

      // note: reads session value that was set from marketing_web after success response (SignUpComponent.js).
      var _window2 = window,
          sessionStorage = _window2.sessionStorage,
          _location = _window2.location;
      var urlParameter = _location.search;


      try {
        var initiatedSignin = sessionStorage.getItem('startSessionLogin');
        var hasChangedPassword = urlParameter.includes('notification=password-changed');
        var loginMethod = hasChangedPassword ? 'password reset' : 'password';
        var uuid = data.uuid;


        if (initiatedSignin || hasChangedPassword) {
          sessionStorage.removeItem('startSessionLogin');
          this._segmentTrackMemberLogin(data, loginMethod);

          if (this.presenter.hasAction(this._indexTrustedDevices)) {
            this.presenter.performAction(this._indexTrustedDevices, null, function (data) {
              _this._segmentIdentifyActiveMobileDevice(data, uuid);
            });
          }
        }
      } catch (e) {}
      // important: Intentionally left blank to prevent console exception.


      // Init LiveChat, at this point, account model is loaded for
      // LiveChat params
      this.node.querySelector(this._classes.nav_items).mogo().initHelpAndSupport();

      // check other models
      this._getFeatureFlags();
      this._getCardsIndexModel();
      this._productSettings.getViewedContents(function (data, response) {
        if ((data !== undefined || response !== undefined) && _this.isGeneralConnectionIssue(data, response)) {
          _this.invokeConnectionIssuePage({
            action: 'account.index_member_contents'
          }, {
            productLabel: 'MogoAccount'
          });
        } else {
          _this.routeRequest();
          _this.analytics.pushEvent('login-account-data', {
            UUID: [_this.presenter.models.account.uuid],
            AccountCreationDate: [_this.presenter.models.account.created_at],
            MemberCreationDate: [_this.presenter.models.account.profile_completed_at],
            LTV: [_this.presenter.models.account.life_time_value]
          });
          _this.pushProductsOfInterestAnalytics();
        }
      });
    }
  };

  this._segmentTrackMemberLogin = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(data, loginMethod) {
      var _window3, analytics, uuid, member_id, created_at, email, first_name, last_name, birthday, street, city, postalCode, _data$country, country, province, suite, phone, _data$account_type, account_type, verification_level, credit_score, credit_history_since, _data$signup_platform, signup_platform, referred_by_id, is_referral, addressObj, e164Phone;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _window3 = window, analytics = _window3.analytics;
              uuid = data.uuid, member_id = data.member_id, created_at = data.created_at, email = data.email_address, first_name = data.first_name, last_name = data.last_name, birthday = data.birth_date, street = data.address, city = data.city, postalCode = data.postal_code, _data$country = data.country, country = _data$country === undefined ? 'Canada' : _data$country, province = data.province, suite = data.suite, phone = data.phone_number, _data$account_type = data.account_type, account_type = _data$account_type === undefined ? 'mogo member' : _data$account_type, verification_level = data.verification_level, credit_score = data.credit_score, credit_history_since = data.credit_history_since, _data$signup_platform = data.signup_platform, signup_platform = _data$signup_platform === undefined ? 'web' : _data$signup_platform, referred_by_id = data.referred_by_id;
              is_referral = referred_by_id !== null ? '1' : '0';
              addressObj = {
                city: city,
                country: country,
                postalCode: postalCode,
                province: province,
                street: street,
                suite: suite
              };
              _context.prev = 4;

              if (!(phone !== null && phone !== '')) {
                _context.next = 11;
                break;
              }

              e164Phone = phone.length === 10 ? '1' + phone : phone;
              _context.next = 9;
              return analytics.identify(uuid, {
                userId: uuid,
                member_id: member_id,
                createdAt: created_at,
                email: email,
                firstName: first_name,
                lastName: last_name,
                birthday: birthday,
                address: addressObj,
                phone: e164Phone,
                account_type: account_type,
                verification_level: verification_level,
                credit_score: credit_score,
                credit_history_since: credit_history_since,
                signup_platform: signup_platform,
                is_referral: is_referral
              });

            case 9:
              _context.next = 13;
              break;

            case 11:
              _context.next = 13;
              return analytics.identify(uuid, {
                userId: uuid,
                member_id: member_id,
                createdAt: created_at,
                email: email,
                firstName: first_name,
                lastName: last_name,
                birthday: birthday,
                address: addressObj,
                account_type: account_type,
                verification_level: verification_level,
                credit_score: credit_score,
                credit_history_since: credit_history_since,
                signup_platform: signup_platform,
                is_referral: is_referral
              });

            case 13:
              _context.next = 15;
              return analytics.track('Member Logged In', { login_method: loginMethod });

            case 15:
              _context.next = 19;
              break;

            case 17:
              _context.prev = 17;
              _context.t0 = _context['catch'](4);

            case 19:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2, [[4, 17]]);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();

  this._segmentIdentifyActiveMobileDevice = function (data, uuid) {
    var _window4 = window,
        analytics = _window4.analytics;
    var authenticated_devices = data.authenticated_devices;

    var has_active_mobile_device = authenticated_devices.length !== 0 ? '1' : '0';

    analytics.identify(uuid, {
      userId: uuid,
      has_active_mobile_device: has_active_mobile_device
    });
  };

  this._getCardsIndexModel = function () {
    // Check if card action exists
    if (this.presenter.hasAction('account.index_cards')) {
      // Card model doesn't exist or is still pending data
      if (this.presenter.models.cards == null || !this.presenter.models.cards._initialized) {
        // No card model
        if (this.presenter.models.cards == null) {
          this.presenter.createModel('cards', {
            action: 'account.index_cards'
          });
        }
        this._initDataCallback = this.presenter.addCallbackToAction('account.index_cards', this._onGetCardsIndexModel.bind(this));
      } else {
        // cards index already exists
        this._onGetCardsIndexModel();
      }
    }
  };

  this._onGetCardsIndexModel = function (data, response) {
    if (arguments.length > 0 && this.isGeneralConnectionIssue(data, response)) {
      if (location.pathname !== this._DEFAULT_LOGGEDIN_PATH) {
        // Only show connection issue page if not on dashboard home
        this.invokeConnectionIssuePage({
          action: 'account.index_cards'
        }, {
          productLabel: 'MogoCard'
        });
      }
    } else {
      if (!this.presenter.models.cards._initialized) {
        try {
          this.presenter.updateModel('cards', data);
        } catch (e) {}
      }

      if (data.body && data.body.length !== 0) {
        try {
          this.presenter.createModel('card', {
            data: data.body.sort(function (a, b) {
              return new Date(b.created_at) - new Date(a.created_at);
            })[0]
          });
        } catch (e) {
          // Already being updated
        }
      }
      var createdAt = void 0;
      if (this.presenter.models.card && this.presenter.models.card.created_at) {
        createdAt = this.presenter.models.card.created_at;
      }
      this.analytics.pushEvent('login-card-data', {
        CardSignupDate: [createdAt]
      });
    }
  };

  this._getFeatureFlags = function () {
    if (this.presenter.hasAction('account.index_feature_flags')) {
      this.presenter.addCallbackToAction('account.index_feature_flags', this._onGetFeatureFlags.bind(this));
      this.presenter.performAction('account.index_feature_flags');
    }
  };

  this._onGetFeatureFlags = function (data, response) {
    if (this.isGeneralConnectionIssue(data, response)) {
      this.invokeConnectionIssuePage({
        action: 'account.index_feature_flags'
      }, {
        productLabel: 'MogoAccount'
      });
    } else {
      if (!this.presenter.models.featureFlags) {
        this.presenter.createModel('featureFlags');
      }
      if (data.feature_flags) {
        for (var flagIndex = 0; flagIndex < data.feature_flags.length; flagIndex++) {
          var flag = data.feature_flags[flagIndex];
          if (!this.presenter.getModelProperty('featureFlags.' + flag.product)) {
            this.presenter.setModelProperty('featureFlags.' + flag.product, {});
          }
          this.presenter.setModelProperty('featureFlags.' + flag.product + '.' + flag.feature_name, flag.feature_on);
        }
      }
    }
    this.presenter._featureFlagsLoadedPromise.resolve();
  };

  this._initHistory = function () {
    // Push state
    $(window).on('pushstate', this._onPushState.bind(this));

    // Initiate history, pass in popstate
    this.history = new History(this._onPopState.bind(this));
  };

  this._onPushState = function (event) {
    this.routeRequest();
  };

  this._onPopState = function (href, data) {
    if (this._initialized) this.routeRequest();
  };

  this._clearTransitions = function () {
    this.$node.removeClass(this._classes.layout_transition);
  };

  this.routeRequest = function () {
    var _this3 = this;

    var prev = this.uri;
    if (prev) {
      prev.section = prev.path.split('/member/dashboard/')[1].split('/')[0].toUpperCase().replace(/-/g, '');
    }

    var route = this.getRouteObj(window.location.pathname);

    // Invalid route, redirect to dashboard (default view)
    if (!route) {
      this.history.replaceUrl(this.getDefaultView());
      return;
    }

    // Route is the same as the previous
    if (route === prev && this.uri.primaryState !== 'routeOnHashChange') {
      return;
    }

    route.path = window.location.pathname;

    this.uri = route;

    this.uri.section = window.location.pathname.split('/member/dashboard/')[1].split('/')[0].toUpperCase().replace(/-/g, '');

    // Update layout based on route
    this._updateLayout(prev, this.uri);

    // Set Active Section:
    var _section = this.uri.section;
    if (_section) {
      window.mogo.registry.mogoUI.appState.dispatch(this.setActiveSection(_section));
    }

    var _previous = prev ? prev.path : '';
    window.mogo.registry.mogoUI.appState.dispatch(this.setActiveURIs(route.path, _previous));

    // To know when ALL parts of the page have been completed loaded (HTML, Parsed, Contentful)
    this.allPartsLoadedPromiseArr = [];

    this._toptrayInitialized = $.Deferred();
    this._traysideInitialized = $.Deferred();
    this._subnavInitialized = $.Deferred();
    this._primaryInitialized = $.Deferred();
    this._trayInitialized = $.Deferred();

    if (this.uri.page_config && this.uri.page_config.defer_page_load_completed) {
      if (this._DEBUG) console.log('defer_page_load_completed set.');
      this.ExtraPageLoadPromise = $.Deferred(); // must be resolved manually in Page component file
      this.allPartsLoadedPromiseArr.push(this.ExtraPageLoadPromise);
    }

    // Process individual views
    this._switchToView(this._$toptray, this.uri.toptray, this.uri.toptrayState, this._toptrayInitialized);
    this._switchToView(this._$trayside, this.uri.trayside, this.uri.traysideState, this._traysideInitialized);
    this._switchToView(this._$subnav, this.uri.subnav, this.uri.subnavState, this._subnavInitialized);
    this._switchToView(this._$primary, this.uri.primary, this.uri.primaryState, this._primaryInitialized);
    this._switchToView(this._$tray, this.uri.tray, this.uri.trayState, this._trayInitialized);

    $.when.apply(null, this.allPartsLoadedPromiseArr).then(function () {
      _this3._portalEntirePageLoadComplete();
      _this3._trackSegmentPageview(_this3.uri);
    });
  };

  this._updateLayout = function (previous, next) {
    var _node$classList, _node$classList2;

    var outgoingLayoutClasses = [];
    var incomingLayoutClasses = [];
    var oldLayout = this._getLayoutClass(previous);
    var newLayout = this._getLayoutClass(next);
    var isAnimatable = this._isDefaultLayout(oldLayout) && !this._isDefaultLayout(newLayout) || !this._isDefaultLayout(oldLayout) && this._isDefaultLayout(newLayout);
    var isAnimatedResolution = this.largeRange || this.xlargeRange;
    var shouldAnimate = this._animated && isAnimatable && isAnimatedResolution;
    var sectionChanged = (!previous || previous.section !== next.section) && next.class && next.class.includes('js--loader-enabled');

    if (shouldAnimate) {
      this.$node.addClass(this._classes.layout_transition);
    }

    this._startPageLoadingDisplay(sectionChanged);

    if (oldLayout) outgoingLayoutClasses.push.apply(outgoingLayoutClasses, _toConsumableArray(oldLayout.split(' ')));
    if (previous && previous.class) outgoingLayoutClasses.push.apply(outgoingLayoutClasses, _toConsumableArray(previous.class.split(' ')));
    if (newLayout) incomingLayoutClasses.push.apply(incomingLayoutClasses, _toConsumableArray(newLayout.split(' ')));
    if (next && next.class) incomingLayoutClasses.push.apply(incomingLayoutClasses, _toConsumableArray(next.class.split(' ')));

    (_node$classList = this.node.classList).remove.apply(_node$classList, outgoingLayoutClasses);
    (_node$classList2 = this.node.classList).add.apply(_node$classList2, incomingLayoutClasses);

    if (shouldAnimate) {
      this._$tray.one(this._transitionEnd, this._clearTransitions.bind(this));
    }
  };

  this._isDefaultLayout = function (layoutClass) {
    return layoutClass === this._classes.layout_default || layoutClass === this._classes.layout_default_no_side;
  };

  // Content is the individual items in _Routes.js
  this._getLayoutClass = function (content) {
    if (content) {
      // Primary
      var _ppDefault = content.primary && !content.tray && content.trayside && !content.subnav;
      var _ppDefaultNoSide = content.primary && !content.tray && !content.trayside && !content.subnav;
      // Tab
      var _ppTopTrayDefault = content.primary && content.toptray && !content.tray && content.trayside && !content.subnav;
      var _ppTopTrayDefaultNoSide = content.primary && content.toptray && !content.tray && !content.trayside && !content.subnav;
      // Tray
      var _ppTrayNoSide = !content.primary && content.tray && !content.trayside;
      var _ppTray = !content.primary && content.tray && content.trayside;
      var _ppTraySideOnly = content.primary && !content.tray && content.trayside && content.subnav;

      if (_ppDefault) {
        // if Top Tray
        if (_ppTopTrayDefault) return this._classes.layout_default + ' ' + this._classes.layout_top_tray;

        return this._classes.layout_default;
      }
      if (_ppDefaultNoSide) {
        // if Top Tray
        if (_ppTopTrayDefaultNoSide) return this._classes.layout_default_no_side + ' ' + this._classes.layout_top_tray;

        return this._classes.layout_default_no_side;
      }
      if (_ppTrayNoSide) {
        return this._classes.layout_tray_no_side;
      }
      if (_ppTray) {
        return this._classes.layout_tray;
      }
      if (_ppTraySideOnly) {
        return this._classes.layout_tray_side_only;
      }
    }
  };

  this._switchToView = function ($view, view, viewState, loadPromise) {
    if ($view.data('view') === view && $view.data('viewState') === viewState && viewState !== 'routeOnHashChange') {
      return; // no change to the view
    }

    // Abort existing requests
    if ($view.data('request') && $view.data('request').state() !== 'resolved') {
      // Abort HTML request
      $view.data('request').abort();
      $view.removeData('request');
      if (this._DEBUG) console.log('abort: ' + $view[0].classList[0]);
    } else {
      // HTML request has already completed

      // Abort Contentful requests if it exists
      if (Object.keys(this._viewStates[$view[0].classList[0]].contentful).length > 0) {
        // Abort current Contentful requests
        this._viewStates[$view[0].classList[0]].contentful = {};
        if (this._DEBUG) console.log('contentful abort: ' + $view[0].classList[0]);
      }

      // Destroy page component
      if ($view[0].innerHTML !== '') {
        this._unloadView($view.find('[data-mogo-page]'));
        $view[0].innerHTML = '';
        if (this._DEBUG) console.log('destroy page ' + $view[0].classList[0]);
      }
    }

    // reset content ready flag
    this.presenter._contentLoadedPromise = $.Deferred();

    // Additional cleanup
    $view.find('.portal__overlay').remove();
    $view.removeData('view').removeData('viewState').empty();

    // Don't load this view, leave empty after unloading
    if (!view) return;

    // Set current view to pending
    this._viewStates[$view[0].classList[0]].status = 'pending';
    if (this._DEBUG) console.log('set ' + $view[0].classList[0] + ' to pending');

    // include this view in total set of views required to complete the total 'page load'
    this.allPartsLoadedPromiseArr.push(loadPromise);

    $view.data('view', view).data('viewState', viewState)
    // .addClass('portal__primary--loading') DEPRECATING BUCKET LOADING CSS
    .data('request', this._ajaxLoadContent($view, '/member/' + view, loadPromise.resolve, loadPromise.reject).always(function () {
      // HTML done loading
      $view.removeData('request');
      // $view.removeClass('portal__primary--loading');  DEPRECATING BUCKET LOADING CSS
      // clear overlay if tray empty
      if ($view[0].innerHTML === '<div class="portal__overlay"></div>') {
        $view[0].innerHTML = '';
      }
    }));
  };

  this._unloadView = function (nodes) {
    if (nodes.length > 0) {
      for (var i = 0; i < nodes.length; i++) {
        $(nodes[i]).mogo().destroy();
      }
    }
  };

  this._ajaxLoadContent = function ($container, url, resolve, reject) {
    var _this4 = this;

    return $.ajax({
      url: url,
      async: true
    }).done(function (response) {
      $container.html(response);
      _this4._onAjaxLoadContent($container, resolve);
      var overlay = document.createElement('div');
      overlay.addClass('portal__overlay');
      $container.append(overlay);
    }).fail(reject);
  };

  this._onAjaxLoadContent = function ($container, resolve) {
    // Parse ui components
    $container.mogo().parse('ui');

    // load contentful content
    var pageComponents = $('[data-mogo-page]', $container);
    var contentful = [];
    this.allPagesInThisPartLoadedPromiseArr = []; // Page Content Loaded and Parsed

    for (var i = 0; i < pageComponents.length; i++) {
      this.allPagesInThisPartLoadedPromiseArr[i] = $.Deferred();
      var contentType = pageComponents[i].dataset.mogoPageContentType; // Contentful Entry Model Type
      var contentId = pageComponents[i].dataset.mogoPageContentId; // Contentful Entry Id

      if (contentId === 'auto') {
        var autoId = window.location.hash.slice(1);
        contentId = autoId;
      }

      // Request contentful content if type and id specified and haven't saved already
      if (contentType && contentId && typeof this.presenter.getModelProperty('content.' + contentType + '.' + contentId) === 'undefined') {
        // Mogo Page or MoneyUp App System:
        var spaceId = contentType === 'page' ? ContentfulSpaceParams.space_id : ContentfulAppSpaceParams.space_id;
        var token = contentType === 'page' ? ContentfulSpaceParams.accessToken : ContentfulAppSpaceParams.accessToken;
        var queryType = contentType === 'page' ? 'ENTRIES_FROM_MODEL_BY_NAME' : 'ENTRIES_FROM_MODEL_BY_ID';

        contentful[i] = new Contentful(_ContentfulConfiguration, $.extend({}, ContentfulSpaceParams, {
          space_id: spaceId,
          accessToken: token,
          verboseLevel: 1
        }));

        contentful[i].getResource(queryType, {
          model_id: contentType,
          name_value: contentId
        }, this._onLoadContentfulData.bind(this, $container, contentType, contentId, this._parsePage.bind(this, pageComponents[i], this.allPagesInThisPartLoadedPromiseArr[i])));
        this._viewStates[$container[0].classList[0]].status = 'contentful';
        this._viewStates[$container[0].classList[0]].contentful[contentId] = true;
        if (this._DEBUG) {
          console.log('set ' + $container[0].classList[0] + ' to contentful [' + contentId + ']');
        }
      } else {
        this._parsePage(pageComponents[i], this.allPagesInThisPartLoadedPromiseArr[i]);
      }
    }

    $.when.apply(null, this.allPagesInThisPartLoadedPromiseArr).done(function ($container, resolve) {
      var _this5 = this;

      // scanNodeForClickAnalytics must be called before initializeHistoryOnDocument
      // to setup click and pushState events in the correct order for analytics

      // 1. Initialize analytics
      this.scanNodeForClickAnalytics($container);

      // 2. Initialize history
      this.history.initializeHistoryOnDocument($container);

      // Scan DOM
      mogo.ready(function () {
        _this5.presenter.scanDOM($container);
      });

      if (this._DEBUG) {
        var _contentId = $container[0].querySelector('[data-mogo-page]') ? $container[0].querySelector('[data-mogo-page]').dataset.mogoPageContentId : null;
        console.log('set ' + $container[0].classList[0] + ' [' + _contentId + '] to complete');
      }
      this._viewStates[$container[0].classList[0]].status = 'complete';
      resolve(); // resolves the allPartsLoadedPromiseArr promise for this part ("layout bucket")
    }.bind(this, $container, resolve));
  };

  this._parsePage = function (page, deferred) {
    var $page = $(page);
    var pageClass = $page.attr('data-mogo-page');

    // Retrieve parameters
    var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/; // Check for JSON object
    var getData = function getData(data) {
      if (data === 'true') return true;
      if (data === 'false') return false;
      if (data === 'null') return null;
      // Only convert to a number if it doesn't change the string
      if (data === '' + +data) return +data;

      if (rbrace.test(data)) {
        try {
          return JSON.parse(data);
        } catch (e) {}
      }
      return data;
    };
    var dataset = $page[0].dataset;

    var params = {};
    for (var key in dataset) {
      if (key.indexOf('mogoPage') == 0) {
        var prop = key.replace('mogoPage', '');
        if (prop != '') {
          prop = prop.substring(0, 1).toLowerCase() + prop.substring(1);
          params[prop] = getData(dataset[key]);
        }
      }
    }

    // Create page with parameters
    $page.mogo().create(pageClass, $.extend(params, {
      presenter: this.presenter,
      analytics: this.analytics
    }), 'page');
    deferred.resolve();
  };

  this._onLoadContentfulData = function (container, contentType, contentId, onComplete, data) {
    if (!this.presenter.models.content) {
      this.presenter.createModel('content', {
        data: {}
      });
    }

    if (data && _typeof(data.items) === 'object' && data.items.length) {
      var contentTree = data.items[0];
      if (contentType === 'page') {
        contentTree = this._buildContentTree(contentTree); // Additional parsing for page content type system
        this.presenter.setModelProperty('content.pages.' + contentId, contentTree); // 'pages' instead of 'page' (backwards compat)
      } else {
        this.presenter.setModelProperty('content.' + contentType + '.' + contentId, contentTree);
      }
      this.presenter._contentLoadedPromise.resolve();
    } else {
      this.presenter.setModelProperty('content.' + contentType + '.' + contentId, {});
    }
    if (this._viewStates[$(container)[0].classList[0]].contentful[contentId] != null) {
      delete this._viewStates[$(container)[0].classList[0]].contentful[contentId];
      if (this._DEBUG) {
        console.log('set ' + $(container)[0].classList[0] + ' to contentful [' + contentId + '] complete');
      }
      onComplete();
      return;
    }
    if (this._DEBUG) {
      console.log('set ' + $(container)[0].classList[0] + ' to contentful [' + contentId + '] abort');
    }
  };

  this._buildContentTree = function (contentfulNode) {
    var node = {};

    for (var childName in contentfulNode) {
      if (contentfulNode.hasOwnProperty(childName) && childName.charAt('0') !== '_') {
        var childNode = contentfulNode[childName];
        if (childNode instanceof Array && childNode.length) {
          for (var i = 0; i < childNode.length; i++) {
            var list = childNode[i];
            if (list.name || list.key) {
              node[list.name || list.key] = this._buildContentTree(list);
            }
          }
        } else {
          node[childName] = childNode;
        }
      }
    }
    return node;
  };

  this.scanNodeForClickAnalytics = function (rootNode) {
    if (!rootNode) rootNode = document;
    var nodes = $(rootNode).find('[data-analytics-id]');
    if (nodes.length > 0) {
      for (var i = 0; i < nodes.length; i++) {
        var node = nodes[i];
        if (node.tagName.toUpperCase() !== 'FORM') {
          $(node).off('click.analytics');
          $(node).on('click.analytics', this._onClickAnalyticsIdNode.bind(this));
        }
      }
    }
  };

  this._onClickAnalyticsIdNode = function (evt) {
    var label = $(evt.currentTarget).attr('data-analytics-id');
    if (label) {
      this.analytics.forcePushEvent('generic-member-navigation', {
        memberNavigation: [label]
      });
    }
  };

  /*
  Marketing Target Analytics pushes products_of_interests datalayer event.
  It is backwards compatable which means it supports nested products_of_interests objs.
  this function is called in: CreditCheck.js and _portalPresenter.js
  */
  this.pushProductsOfInterestAnalytics = function () {
    // Push Marketing Retarget Analytics for existing and new sign up users
    // Products of interest analytics
    var analyticsObject = {};
    var _productsOfInterest = this.presenter.getModelProperty('account.products_of_interest') ? this.presenter.getModelProperty('account.products_of_interest') : false;
    // If first item in products_of_interest is a string, this means it's new schema
    // build out analyticsObject
    if (_productsOfInterest) {
      // Old nested schema
      for (var i = 0; i < _productsOfInterest.length; i++) {
        // backwards compat: '.product' is old schema format)
        if (_productsOfInterest[i] === 'loan' || _productsOfInterest[i].product === 'loan') {
          analyticsObject.loanInterestPurpose = [_productsOfInterest[i].credit_purpose];
          analyticsObject.loanInterestAmount = [_productsOfInterest[i].requested_credit_amount];
          analyticsObject.loanInterest = [true];
        }
        if (_productsOfInterest[i] === 'spending_account' || _productsOfInterest[i].product === 'spending_account') {
          analyticsObject.cardInterest = [true];
        }
        if (_productsOfInterest[i] === 'mortgage' || _productsOfInterest[i].product === 'mortgage') {
          analyticsObject.mortgageInterest = [true];
        }
        if (_productsOfInterest[i] === 'monthly_credit_score' || _productsOfInterest[i].product === 'monthly_credit_score') {
          analyticsObject.creditScoreInterest = [true];
        }
        if (_productsOfInterest[i] === 'identity_protection' || _productsOfInterest[i].product === 'identity_protection') {
          analyticsObject.identityFraudInterest = [true];
        }
        if (_productsOfInterest[i] === 'bitcoin' || _productsOfInterest[i].product === 'bitcoin') {
          analyticsObject.bitcoinInterest = [true];
        }
      }

      // Override obj's loanInterestPurpose depending on new or old schema format
      if (typeof _productsOfInterest[0] === 'string') {
        // Available to retrieve from presenter
        analyticsObject.loanInterestPurpose = [this.presenter.models.account.credit_purpose];
        analyticsObject.loanInterestAmount = [this.presenter.models.account.requested_credit_amount];
      }
      // need to put push event in if statement because Profile Info is part of portal
      this.analytics.forcePushEvent('products-of-interest', analyticsObject);
    }
  };

  // _getThemeCategory: retrieves the referral Original url
  // uses the referral url to determine the return the category variable
  this._getThemeCategory = function () {
    var category = false;

    // Retrieve origin sign up url
    if (Cookies.getJSON('formdata_profileinfo_loanInterest')) category = 'money';

    return category;
  };

  // setTargetAudience: sets the theme, depending on the theme category
  // adds category class to Portal and pushes analytics
  // removes default-no-theme so the top border for trays are touch red.
  this.setupTargetAudience = function () {
    var category = this._getThemeCategory();

    if (category == false || this.$node.hasClass('default-no-theme')) {
      this.$node.removeClass('default-no-theme');
    }

    if (category && category === 'money') {
      this.presenter.addComputedVariable('profile_info_theme', ['account'], function () {
        return 'money';
      });

      // Add money to portal to init theme
      this.$node.addClass('money');

      // Push analytics
      this.analytics.pushEvent('targeted-audience', {
        targetedAudience: ['loanInterest']
      });
    }
  };

  // removeTheme: removes tge theme category class
  // so users will enter portal with no funny business / styles
  this.removeTargetAudience = function () {
    var category = this._getThemeCategory();

    if (this.$node.hasClass(category)) this.$node.delay(500).removeClass(category);

    // Remove addComputedVariable from setupTargetAudience
    this.presenter.removeComputedVariable('profile_info_theme');

    // remove formdata_profile Cookies
    // so the default theme will show for new users
    Cookies.remove('formdata_profileinfo_loanInterest');
    Cookies.remove('formdata_profileinfo_creditPurpose');
    Cookies.remove('formdata_profileinfo_creditAmount');
  };

  this._portalEntirePageLoadComplete = function () {
    this._finishPageLoadingDisplay();
  };

  this._startPageLoadingDisplay = function (sectionChanged) {
    // hide common section elements (tabs, home__banner, content-centre, etc)
    // if you're changing to another section
    if (sectionChanged) {
      this.$node.addClass(this._classes.layout_loader);
    }

    // reset
    this.$node.removeClass('portal--dashboard-loader-loaded');
  };

  // PAGE LOAD COMPLETE:
  this._finishPageLoadingDisplay = function () {
    // show common section elements (tabs, home__banner, content-centre, etc)
    // now that we know the user will stay on this page and the page is done loading
    this.$node.removeClass(this._classes.layout_loader);

    // this.$node.addClass('portal--dashboard-loader-loaded');
  };

  // called by external page components manually to say when they are done.
  this.setPageLoadComplete = function () {
    if (this.ExtraPageLoadPromise) {
      this.ExtraPageLoadPromise.resolve();
    } else {
      console.warn('defer_page_load_completed not set for this page.');
    }
  };

  // note: Segment Global Page & Track Events.
  this._trackSegmentPageview = function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(uri) {
      var _window5, analytics, location, isArticlePage, articleTitle, generatedPageName;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _window5 = window, analytics = _window5.analytics, location = _window5.location;
              isArticlePage = location.pathname.endsWith('/educational/articles');
              articleTitle = location.href.split('#')[1];
              generatedPageName = this._generatePageName(uri);
              _context2.prev = 4;

              if (!(isArticlePage && articleTitle)) {
                _context2.next = 10;
                break;
              }

              _context2.next = 8;
              return analytics.page(generatedPageName, { article_title: articleTitle });

            case 8:
              _context2.next = 12;
              break;

            case 10:
              _context2.next = 12;
              return analytics.page(generatedPageName);

            case 12:
              _context2.next = 14;
              return analytics.track('Screen Viewed', { screen_name: generatedPageName });

            case 14:
              _context2.next = 18;
              break;

            case 16:
              _context2.prev = 16;
              _context2.t0 = _context2['catch'](4);

            case 18:

              if (this._DEBUG) console.log('Track Pageview ' + generatedPageName);

            case 19:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this, [[4, 16]]);
    }));

    return function (_x3) {
      return _ref2.apply(this, arguments);
    };
  }();

  this._generatePageName = function (pageData) {
    if (pageData.page_config && pageData.page_config.page_name) {
      return pageData.page_config.page_name;
    }

    var preFix = '/member/dashboard/';
    var slash = /\//g;
    var hyphen = /-/g;
    var pageName = window.location.pathname;
    // pageName = pageName.substr(preFix.length).replace(/\//g, ' ').replace(/-/g, ' ').toLowerCase();
    pageName = pageName.substr(preFix.length).replace(slash, ' ').replace(hyphen, ' ').toLowerCase();
    return pageName;
  };
}